module.exports = __webpack_public_path__ + "img/centerpoint.bd87aae6.svg";